<template>
  <div class="navbar-fixed" style="z-index: 9999; ">
    <nav >
      <div class="nav-wrapper " :style="'background-color: ' + this.$store.state.empresa.cor_primaria">
        <a class="brand-logo">
          <div v-if="!logo" align="center">
            <img src="https://res.cloudinary.com/sirrus/image/upload/v1606568320/delivery/modas/assets/logo_yxqfgw.png" class="logo">
          </div>
          <div v-else align="center"><img :src="logo" class="logo"></div>
        </a>

        <a class="right" @click="compartilhar()">
          <i class="material-icons" :style="'font-size: 25px; color: #fff;margin-right: 7px;'">share</i>
        </a>

        <slot></slot>
      </div>
    </nav>
  </div>
</template>

<script>
  import Swal from "sweetalert2";

  export default {
    name: "NavBarComponent",
    props:["logo"],
    methods:{
      generateUrl() {
        return `https://pedido.sirrusmoda.app/${this.$store.state.empresa.usuario_url}${(!this.$store.state.is_producao ? '?homologacao=true' : '')}`;
      },
      async compartilhar()
      {
        if (navigator.share)
        {
          this.compartilharComImagem(this.generateUrl());
        } else {
          this.copiarParaAreaDeTransferencia(this.generateUrl());
        }
      },
      async compartilharComImagem(newUrl) {
        navigator.share({
          url: newUrl
        })
          .then(() => console.log('Successful share'))
          .catch((error) => console.error('Error sharing:', error));
      },
      copiarParaAreaDeTransferencia(texto) {
        const el = document.createElement('textarea');
        el.value = texto;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        Swal.fire({
          icon: 'success',
          title: 'Link copiado!',
          text: 'Agora você já pode compartilhar nosso cardápio :)'
        });
      }
    }
  }
</script>

<style scoped>
  .logo {
    max-height: 65px;
    padding: 5px;
  }
  .icone{
      padding-top: 0px;
  }
  @media only screen and (max-width : 992px) {
    .logo {
      padding-top: 7px;
      max-height: 55px;
    }
  }
  @media only screen and (max-width : 440px) {
    .logo {
      padding-top: 5px;
      max-height: 50px;
    }
    .icone{
      padding-top: 15px;
    }
  }
  .sidenav li > a {
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/app/components/NavBarComponent.vue